import { API_AUTH } from './common';

const CuaHangDoiTacApi = {
  combo: () => API_AUTH.get(`cua-hang-doi-tac/combo`, {}),
};

export default CuaHangDoiTacApi;
